import axios from 'axios';

const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001'
    : process.env.REACT_APP_SIDEKICK_URL;

const API = axios.create({
    baseURL,
    withCredentials: true,
});

// Login through the backend API and return response data
export async function login({ email, password }) {
    try {
        console.log('Sending login request with:', { email, password }); // Added logging
        const response = await API.post('/api/login', { email, password });
        if (response.status === 200) {
            console.log('/api/login success', response.data);
            return response.data;
        }
        console.log('/api/login failure:', response);
        return { success: false, message: 'Invalid response status' };
    } catch (error) {
        console.error('/api/login error:', error);
        return { success: false, message: error.message };
    }
}

const authAPI = {
    login,
};

export default authAPI;
